import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AgreementDetailService } from './agreement-detail.service';
import * as _moment from 'moment';
import { NotificationsService } from 'angular2-notifications';
import { ReceiveSingleSettlementDialogComponent } from './receive-single-settlement-dialog/receive-single-settlement-dialog.component';
import { AddBoletoDialogComponent } from './add-boleto-dialog/add-boleto-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';
import { NgxSpinnerService } from 'ngx-spinner';

const moment = _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/yyyy',
    },
    display: {
        dateInput: 'MM/yyyy',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'DD',
        monthYearA11yLabel: 'MMMM yyyy',
    },
};

@Component({
    selector: 'agreement-detail',
    templateUrl: './agreement-detail.component.html',
    styleUrls: ['./agreement-detail.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class AgreementDetailComponent implements OnInit {
    agreement: any;
    date = new FormControl(moment());
    accountAgreementDto: any;
    loading: boolean = true;

    constructor(
        private router: Router,
        private notification: NotificationsService,
        private AgreementDetailService: AgreementDetailService,
        private dialog: MatDialog,
        private authService: AuthServiceCustom,
        private spinner: NgxSpinnerService,
        private _cdRef: ChangeDetectorRef,
    ) {}

    showLoad(value: boolean) {
        this.loading = value;
        if (this.loading) {
            this.spinner.show();
        } else {
            this.spinner.hide();
        }
        this._cdRef.detectChanges();
    }

    ngOnInit(): void {
        const nav = this.router.getCurrentNavigation();

        this.agreement = nav?.extras?.state?.['agreement'] ?? history.state?.agreement;

        this.date.setValue(moment());

        if (!this.agreement) {
            this.router.navigate(['/agreement-external-collector/manage-agreement']);
            return;
        }
    }

    setMonthAndYear(normalizedMonthAndYear: any, datepicker: MatDatepicker<any>) {
        const ctrlValue = this.date.value ?? moment();
        ctrlValue.month(normalizedMonthAndYear.month());
        ctrlValue.year(normalizedMonthAndYear.year());
        this.date.setValue(ctrlValue);
        datepicker.close();
    }

    onStartAccountingProcess() {
        this.accountAgreementDto = {
            SelectedDate: moment(this.date.value).toISOString(),
            AgreementId: this.agreement._id,
        };

        this.showLoad(true);

        this.AgreementDetailService.startAccountingProcess(this.accountAgreementDto).subscribe((result) => {
            this.showLoad(false);

            if (result.isSuccess) {
                this.agreement.status = 'Contabilizado';
                this.agreement.statusId = 4;
                this.notification.create('Sucesso', 'Contabilizado com sucesso');
            }
        });
    }

    get canModifyBoletos(): boolean {
        return this.agreement?.statusId === 1;
    }

    onAddBoleto(): void {
        const dialogRef = this.dialog.open(AddBoletoDialogComponent, {
            width: '700px',
            data: {
                companyId: this.agreement?.companyId,
                codigoAcerto: this.agreement?.codigoAcerto,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (!result || !result.length) return;
            if (!this.agreement.boletos) this.agreement.boletos = [];
            this.agreement.boletos.push(...result);
            this.recalcularTotal();
        });
    }

    onRemoveBoleto(index: number): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: { message: 'Deseja remover este boleto do acerto?' },
        });
        dialogRef.afterClosed().subscribe((confirmed) => {
            if (!confirmed) 
                return;

            this.AgreementDetailService.removeBoletoFromAgreement(
                this.agreement?.companyId,
                this.agreement?.codigoAcerto,
                this.agreement.boletos[index].billetId
            ).subscribe(() => {
                this.agreement.boletos.splice(index, 1);
                this.recalcularTotal();
            });
        });
    }

    private recalcularTotal(): void {
        this.agreement.valorTotal = (this.agreement.boletos || []).reduce((sum, b) => sum + (b.valorPago || 0), 0);
        this._cdRef.detectChanges();
    }

    onReceiveSingleSettlement() {
        const dialogRef = this.dialog.open(ReceiveSingleSettlementDialogComponent, {
            width: '420px',
            data: {
                total: this.agreement?.valorTotal || 0,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (!result?.paymentDate) {
                return;
            }

            const body = {
                Date: result.paymentDate,
                Username: this.authService.userName,
                ExternalCollectorAgreementId: this.agreement?._id,
                Amount: this.agreement?.valorTotal || 0,
            };

            this.showLoad(true);

            this.AgreementDetailService.receiveSingleSettlement(body).subscribe(
                () => {
                    this.showLoad(false);
                    this.notification.create('Sucesso', 'Acerto avulso recebido com sucesso');
                    //change type Recebido
                    this.agreement.statusId = 2;
                    this.agreement.status = 'Pago';
                    this._cdRef.detectChanges();
                },
                () => {
                    this.showLoad(false);
                },
            );
        });
    }
}
